import React from "react";
import logo from "../images/familee_tree_logo.svg";
import { useFormik } from 'formik';
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
 
const validate = values => {
  const errors = {};
  if (!values.mobileNumber) {
    errors.mobileNumber = 'Please enter your mobile number.';
  }
  return errors;
};
const ForgortPasswordMobile = () => {
    const navigate = useNavigate()
      const formik = useFormik({
        initialValues: { mobileNumber: ''},
        validate,
        onSubmit: async (values, { setSubmitting }) => {
          try {
            navigate('/verifyOtp')
          } catch (error) {
              console.error('Login error:', error);
              toast.error(error.response.data.message)
          } finally {
              setSubmitting(false);
          }
      }
    })      
      return  (
        <React.Fragment>
          <div className="login-page">
            <div className="login-container">
              <img src={logo} alt="FamileeTree" className="logo" />
              <form className="login-form" onSubmit={formik.handleSubmit}>
                <div className="input-group">
                  <label htmlFor="mobileNumber">Enter your mobile Number</label>
                  <input 
                  type="number" 
                  id="mobileNumber" 
                  name="mobileNumber" 
                  value={formik.values.mobileNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.mobileNumber && formik.errors.mobileNumber ? <p className="error-message">{formik.errors.mobileNumber}</p> : null}
                <button type="submit">Send OTP</button>
              </form>
              <br/>
              <p>Or</p>
              <div >
              Forgot password using<Link to='/ForgotPasswordEmailId'><span className="login-forget"> Email Address?</span></Link>
              </div>
             
            </div>
          </div>
        </React.Fragment>
      )
};
export default ForgortPasswordMobile;
